// @ts-nocheck
import React from 'react';

const SvgChevronDown = props => (
  <svg viewBox="0 0 64 64" {...props}>
    <path
      d="M33.408 43.43a2 2 0 0 1-2.83 0L15.575 28.418a2 2 0 1 1 2.83-2.83l13.59 13.597 13.59-13.597a2.001 2.001 0 1 1 2.828 2.83z"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgChevronDown;
